import { makeStyles } from '@material-ui/core'
import { colors } from '../../Themes'

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 200,
    backgroundColor: colors.white,
    color: colors.white,
    marginBottom: 24,
    marginInline: 25,
    boxShadow: 'none',
    border: '1px solid ' + colors.gray,
    borderRadius: 5
  },
  headerWrapper: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    marginBottom: 8
  },
  cardContentRoot: {
    display: 'flex',
    flexDirection: 'column',
    padding: '18px 12px',
    whiteSpace: 'normal',
    '&:last-child': {
      paddingBottom: 12
    }
  },
  closeIconButton: {
    color: colors.white,
    padding: 0
  },
  linkTo: {
    color: colors.accent,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: 18,
    textAlign: 'left',
    textDecoration: 'underline'
  },
  iconButtonRoot: {
    padding: 0,
    marginTop: 12,
  },
  closeIcon: {
    padding: 0,
    color: colors.primary,
    position: 'absolute',
    right: 0,
  },
  icon: {
    color: colors.primary,
    marginLeft: 5,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  labelRoot: {
    justifyContent: 'flex-start'
  },
  title: {
    marginLeft: 5
  },
  text: {
    marginTop: 5, 
    lineHeight: 1.4
  }
}))

export default useStyles